/**
 * SettlementDot.jsx — 마케터 전용 정산서 (DOT) 어셈블리
 *
 * 레이아웃:
 *   히어로 헤더 — 순수익 강조 + 차감/수입 요약
 *   탭 네비게이션 — 담당매장 / 미연결결제
 *   담당매장 탭 — 매장 카드 목록 (계약·홍보물 차감 + 연결 결제)
 *   미연결결제 탭 — 카드승인 / 전화승인 / 입금 (탭하여 선택 → 매장 탭에서 연결)
 *
 * 연결 방법 (모바일):
 *   1) 미연결결제 탭에서 항목 탭 → "매장에 연결" 배너 표시
 *   2) 담당매장 탭으로 이동 → 매장 카드 탭하여 연결
 *
 * 분할 구조:
 *   settlementdot/constants.js        — 색상, 그림자, TYPE_CFG
 *   settlementdot/utils.js            — fmt, fmtDate, contractItemsLabel, contractServiceLabel
 *   settlementdot/buildTimeline.js    — 날짜순 뷰 데이터 변환
 *   settlementdot/useSettlementDot.js — 상태·이펙트·핸들러 훅
 *   settlementdot/mobileStylesBase.js — 모바일 스타일 A (레이아웃·카드헤더)
 *   settlementdot/mobileStylesDetail.js — 모바일 스타일 B (상세·결제·타임라인)
 *   settlementdot/mobileStyles.js     — 위 두 파일 병합 재출력
 *   settlementdot/pcStyles.js         — PC 전용 스타일
 *   settlementdot/CommonComponents.jsx — LoadingPlaceholder, EmptyState
 *   settlementdot/CopyTrackingButton.jsx — 송장번호 복사 버튼
 *   settlementdot/StoreCard.jsx       — StoreCard, DetailSection, UnlinkBtn
 *   settlementdot/PayComponents.jsx   — PayGroup, TimelineView, TimelineItem
 *   settlementdot/PcComponents.jsx    — PcSumBadge, PcDetailSection, PcDetailRow,
 *                                       PcUnlinkBtn, PcPayGroup, PcTimelineView
 *   settlementdot/PcStoreCard.jsx     — PcStoreCard
 *   settlementdot/PcView.jsx          — PC 렌더 경로
 *   settlementdot/MobileView.jsx      — 모바일 렌더 경로
 */

import React from 'react';
import { useSettlementDot } from './settlementdot/useSettlementDot';
import { MobileView } from './settlementdot/MobileView';

export default function SettlementDot() {
  const state = useSettlementDot();
  return <MobileView {...state} />;
}
